var map = {
	"./alt.html": 57,
	"./android-icon-144x144.png": 76,
	"./android-icon-192x192.png": 77,
	"./android-icon-36x36.png": 78,
	"./android-icon-48x48.png": 79,
	"./android-icon-72x72.png": 80,
	"./android-icon-96x96.png": 81,
	"./apple-icon-114x114.png": 82,
	"./apple-icon-120x120.png": 83,
	"./apple-icon-144x144.png": 84,
	"./apple-icon-152x152.png": 85,
	"./apple-icon-180x180.png": 86,
	"./apple-icon-57x57.png": 87,
	"./apple-icon-60x60.png": 88,
	"./apple-icon-72x72.png": 89,
	"./apple-icon-76x76.png": 90,
	"./apple-icon-precomposed.png": 91,
	"./apple-icon.png": 92,
	"./browserconfig.xml": 58,
	"./favicon-16x16.png": 93,
	"./favicon-32x32.png": 94,
	"./favicon-96x96.png": 95,
	"./favicon.ico": 59,
	"./img/mscore.png": 96,
	"./img/mscore_long.png": 97,
	"./loading.html": 60,
	"./login.html": 61,
	"./manifest": 9,
	"./manifest.json": 9,
	"./ms-icon-144x144.png": 98,
	"./ms-icon-150x150.png": 99,
	"./ms-icon-310x310.png": 100,
	"./ms-icon-70x70.png": 101
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;



//////////////////
// WEBPACK FOOTER
// ./static .*
// module id = 105
// module chunks = 0